import React from "react";
import {
  Box,
  Container,
  Typography,
  TextField,
  Button,
  Grid,
} from "@mui/material";
import { motion } from "framer-motion";

// Import Assets
import contactImg from "../../Assets/ContactSection/Contact section image.svg";

const ContactSection = () => {
  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: "1280px",
        pt: { xs: "0px", md: "48px" },
        pb: { xs: "0px", md: "80px" },
        px: { xs: "0px", md: "32px" },
        mx: "auto",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: "1216px",
          height: { xs: "auto", md: "811px" },
          backgroundColor: "#F6F3F2",
          borderRadius: "10px",
          boxShadow: "2px 2px 10px 0px #0000000D",
          overflow: "hidden",
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        {/* Left Side - Content/Form */}
        <Box
          sx={{
            flex: 1,
            backgroundColor: "#1C1917",
            color: "white",
            display: "flex",
            flexDirection: "column",
            p: { xs: "48px 20px", md: 0 },
            alignItems: { xs: "center", md: "flex-start" },
          }}
        >
          <Box
            sx={{
              width: { xs: "100%", md: "360px" },
              height: { xs: "auto", md: "96px" },
              mt: { xs: 0, md: "80px" },
              ml: { xs: 0, md: "69px" },
            }}
          >
            <Typography
              variant="h2"
              sx={{
                fontFamily: "Manrope",
                fontWeight: 800,
                fontSize: { xs: "32px", md: "48px" },
                lineHeight: { xs: "40px", md: "48px" },
                letterSpacing: "-1.2px",
                color: "#FFFFFF",
                textAlign: { xs: "center", md: "left" },
              }}
            >
              Begin Your Transformation
            </Typography>
          </Box>
          <Box
            sx={{
              width: { xs: "100%", md: "448px" },
              height: { xs: "auto", md: "52px" },
              mt: "24px",
              ml: { xs: 0, md: "69px" },
            }}
          >
            <Typography
              sx={{
                fontFamily: "Inter",
                fontWeight: 400,
                fontSize: { xs: "14px", md: "16px" },
                lineHeight: "26px",
                color: "#FFFFFF",
                textAlign: { xs: "center", md: "left" },
                opacity: 0.8,
              }}
            >
              Every masterpiece starts with a conversation. Let us redefine the
              way you live within your walls.
            </Typography>
          </Box>

          {/* Enquiry Form */}
          <Box
            sx={{
              width: { xs: "100%", md: "448px" },
              maxWidth: "448px",
              mt: { xs: "40px", md: "100px" },
              ml: { xs: 0, md: "80px" },
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              pb: { xs: 4, md: 0 },
            }}
          >
            {/* Row 1: Name and Email */}
            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                gap: "32px",
              }}
            >
              {[
                {
                  label: "FULL NAME",
                  placeholder: "Johnathan Doe",
                  name: "fullName",
                },
                {
                  label: "EMAIL ADDRESS",
                  placeholder: "j.doe@studio.com",
                  name: "email",
                  type: "email",
                },
              ].map((field, idx) => (
                <Box
                  key={idx}
                  sx={{
                    width: { xs: "100%", md: "208px" },
                    height: "60px",
                    pt: "8px",
                    pb: "8px",
                    display: "flex",
                    flexDirection: "column",
                    gap: "4px",
                    borderBottom: "1px solid #E2BFB54D",
                  }}
                >
                  <Typography
                    sx={{
                      fontFamily: "Inter",
                      fontSize: "10px",
                      fontWeight: 600,
                      color: "#FF5722",
                      letterSpacing: "1px",
                    }}
                  >
                    {field.label}
                  </Typography>
                  <Box
                    component="input"
                    type={field.type || "text"}
                    placeholder={field.placeholder}
                    sx={{
                      width: "100%",
                      backgroundColor: "transparent",
                      border: "none",
                      outline: "none",
                      color: "#FFFFFF",
                      fontFamily: "Inter",
                      fontSize: "16px",
                      fontWeight: 400,
                      "&::placeholder": {
                        color: "rgba(255, 255, 255, 0.3)",
                      },
                    }}
                  />
                </Box>
              ))}
            </Box>

            {/* Row 2: Project Type */}
            <Box
              sx={{
                width: "100%",
                height: "60px",
                pt: "8px",
                pb: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                borderBottom: "1px solid #E2BFB54D",
                position: "relative",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontWeight: 600,
                  color: "#FF5722",
                  letterSpacing: "1px",
                }}
              >
                PROJECT TYPE
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <Box
                  component="select"
                  sx={{
                    width: "100%",
                    backgroundColor: "transparent",
                    border: "none",
                    outline: "none",
                    color: "#FFFFFF",
                    fontFamily: "Inter",
                    fontSize: "16px",
                    fontWeight: 400,
                    appearance: "none",
                    cursor: "pointer",
                    "& option": {
                      backgroundColor: "#1C1917",
                      color: "#FFFFFF",
                    },
                  }}
                >
                  <option value="" disabled defaultValue>
                    Select project type...
                  </option>
                  <option value="residential">Residential Design</option>
                  <option value="commercial">Commercial Space</option>
                  <option value="architectural">Architectural Planning</option>
                  <option value="consultation">Design Consultation</option>
                </Box>
                <Box
                  component="span"
                  sx={{
                    border: "solid rgba(255, 255, 255, 0.5)",
                    borderWidth: "0 2px 2px 0",
                    display: "inline-block",
                    padding: "3px",
                    transform: "rotate(45deg)",
                    mb: "4px",
                    position: "absolute",
                    right: 0,
                    pointerEvents: "none",
                  }}
                />
              </Box>
            </Box>

            {/* Row 3: Project Brief */}
            <Box
              sx={{
                width: "100%",
                height: "100px",
                pt: "8px",
                pb: "8px",
                display: "flex",
                flexDirection: "column",
                gap: "4px",
                borderBottom: "1px solid #E2BFB54D",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Inter",
                  fontSize: "10px",
                  fontWeight: 600,
                  color: "#FF5722",
                  letterSpacing: "1px",
                }}
              >
                PROJECT BRIEF
              </Typography>
              <Box
                component="textarea"
                placeholder="Describe your vision..."
                sx={{
                  width: "100%",
                  height: "100%",
                  backgroundColor: "transparent",
                  border: "none",
                  outline: "none",
                  color: "#FFFFFF",
                  fontFamily: "Inter",
                  fontSize: "16px",
                  fontWeight: 400,
                  resize: "none",
                  "&::placeholder": {
                    color: "rgba(255, 255, 255, 0.3)",
                  },
                }}
              />
            </Box>

            {/* Submit Button */}
            <Button
              variant="contained"
              sx={{
                width: "100%",
                height: "64px",
                backgroundColor: "#FF5722",
                borderRadius: "8px",
                mt: "16px",
                fontFamily: "Inter",
                fontWeight: 700,
                fontSize: "14px",
                letterSpacing: "2px",
                "&:hover": {
                  backgroundColor: "#E64A19",
                },
              }}
            >
              SUBMIT ENQUIRY
            </Button>
          </Box>
        </Box>

        {/* Right Side - Image */}
        <Box
          sx={{
            flex: 1,
            backgroundColor: "#E5E7EB",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            height: { xs: "350px", md: "100%" },
            order: { xs: -1, md: 1 },
          }}
        >
          <Box
            component="img"
            src={contactImg}
            sx={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default ContactSection;
